import React, { useState } from 'react';
import Layout from '~/components/Layout';
import useStoryblok from '~/utils/storyblok-service';
import FountainForm from '~/components/Forms/Fountain/FountainForm';
import { graphql } from 'gatsby';
import Seo from '~/components/SEO';

function JoinBoom({ data, location, pageContext }) {
  const story = useStoryblok(data.storyblokEntry, location);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const content = story.content;
  // React.useEffect(()=>{
  //   setTimeout(()=>{
  //     setIsSubmitted(true);
  //   },1000)
  // },[])
  return (
    <Layout
      headerColor={`${isSubmitted ? 'black' : 'white'}`}
      className={`${isSubmitted && 'text-white bg-black'}`}
      hideFooter
      hideFooterCta
      hideSecondaryFooterCta
      locale={pageContext.locale}
      >
      <Seo {...content.seo} lang={story.lang} pageContext={pageContext} />
      <FountainForm {...content} isSubmitted={isSubmitted} setIsSubmitted={setIsSubmitted} />
    </Layout>
  );
}

export default JoinBoom;

export const query = graphql`
query JoinBoomQuery($id: String!) {
  storyblokEntry(id: { eq: $id }) {
    id
    name
    content
    lang
    slug
    uuid
    full_slug
  }
}
`;
